import { render, staticRenderFns } from "./LedModal.vue?vue&type=template&id=6fffa826"
import script from "./LedModal.vue?vue&type=script&lang=js"
export * from "./LedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports